module.exports = __webpack_public_path__ + "static/media/icon_car_left_side.fe88be1d.svg";